
/**
 * By Ken Fyrstenberg Nilsen
 *
 * drawImageProp(context, image [, x, y, width, height [,offsetX, offsetY]])
 *
 * If image and context are only arguments rectangle will equal canvas
*/
function drawImageProp(ctx, img) {
	let x = 0;
	let y = 0;
	let w = ctx.canvas.width;
	let h = ctx.canvas.height
	let offsetX = 0.5;
	let offsetY = 0.5;

	let iw = img.width,
		ih = img.height,
		r = Math.min(w / iw, h / ih),
		nw = iw * r,   // new prop. width
		nh = ih * r,   // new prop. height
		cx, cy, cw, ch, ar = 1;

	// console.log(iw, ih);
	// console.log(img.src);

	// decide which gap to fill
	if (nw < w) ar = w / nw;
	if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;
	nw *= ar;
	nh *= ar;

	// calc source rectangle
	cw = iw / (nw / w);
	ch = ih / (nh / h);

	cx = (iw - cw) * offsetX;
	cy = (ih - ch) * offsetY;

	// make sure source rectangle is valid
	if (cx < 0) cx = 0;
	if (cy < 0) cy = 0;
	if (cw > iw) cw = iw;
	if (ch > ih) ch = ih;

	// fill image in dest. rectangle
	ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
}


export default class Eraser {
	constructor(element) {
		this.element = element;
		this.canvas = this.element.querySelector(".eraser-canvas");
		this.canvasContext = this.canvas.getContext("2d");
		this.brush = document.createElement("canvas");
		this.brushContext = this.brush.getContext("2d");

		this.imageElement = this.element.querySelector(".eraser-bg img");
		this.image = null;
		this.points = [];
		this.animationFrame = null;

		this.options = {
			delay: 3000,
			fadeIn: 1500,
			fadeOut: 2500
		};

		// window.addEventListener("resize", function() {
		// 	console.log("resize");
		// });

		this.init();

		this.element.addEventListener("mousemove", this.onMouseMove.bind(this), { passive: true });
	}

	init() {
		let self = this;
		function updateImage(src) {
			let image = new Image();
			image.src = self.imageElement.currentSrc;
			if (image.complete) {
				self.image = image;
			}
			image.onload = function() {
				self.image = image;
			}
		}

		if (this.imageElement.complete) {
			updateImage();
		}
		this.imageElement.onload = updateImage;
	}

	onMouseMove(event) {
		if (!this.image) {
			return;
		}

		let rect = event.target.getBoundingClientRect();
		this.addPoint(
			(event.clientX - rect.left) / rect.width,
			(event.clientY - rect.top) / rect.height
		);

		this.checkPoints();
	}

	addPoint(x, y) {
		this.points.unshift({ time: Date.now(), x: x, y: y });
	}

	clearPoints() {
		let duration = this.options.fadeIn + this.options.delay + this.options.fadeOut;
		let now = Date.now();

		for (let i = 0; i < this.points.length; ++i) {
			if (duration <= (now - this.points[i].time)) {
				this.points.length = i;
			}
		}
	}

	checkPoints() {
		this.clearPoints();

		if (this.points.length) {
			if (!this.animationFrame) {
				this.animationFrame = requestAnimationFrame(this.animateFrame.bind(this));
			}
		}
		else {
			if (this.animationFrame) {
				cancelAnimationFrame(this.animationFrame);
				this.animationFrame = null;
			}
		}
	}

	animateFrame() {
		this.animationFrame = null;
		this.paint();
		this.checkPoints();
	}

	paint() {
		let width = this.element.offsetWidth;
		let height = this.element.offsetHeight;
		this.canvas.width = width;
		this.canvas.height = height;
		this.brush.width = width;
		this.brush.height = height;

		let now = Date.now();

		// Brush
		let context = this.brushContext;
		context.clearRect(0, 0, width, height);
		context.lineCap = "round";
		context.lineWidth = 130;

		for (let i = 1; i < this.points.length; ++i) {
			let previousPoint = this.points[i - 1];
			let currentPoint = this.points[i];
			let time = (now - currentPoint.time);
			let opacity = 1;
			if (time <= this.options.fadeIn) {
				opacity = time / this.options.fadeIn;
			}
			else if (this.options.fadeIn + this.options.delay < time) {
				opacity = 1 - Math.min(time - this.options.fadeIn - this.options.delay, this.options.fadeOut) / this.options.fadeOut;
			}

			context.strokeStyle = "rgba(0, 0, 0, " + opacity + ")";
			context.beginPath();
			context.moveTo(previousPoint.x * width, previousPoint.y * height);
			context.lineTo(currentPoint.x * width, currentPoint.y * height);
			context.stroke();
		}

		// Image
		context = this.canvasContext;
		context.clearRect(0, 0, this.canvas.width, this.canvas.height);
		context.globalCompositeOperation = "source-over";
		drawImageProp(context, this.image);

		context.globalCompositeOperation = "destination-in";
		context.drawImage(this.brush, 0, 0);
	}




};
